import { motion } from 'framer-motion';
import { MapPin, Mail } from 'lucide-react';

const SWIGGY_URL = process.env.REACT_APP_SWIGGY_URL;

export default function Contact() {
  return (
    <div className="min-h-screen py-24 bg-cream">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-playfair font-bold text-brown-dark mb-4">
            Contact Us
          </h1>
          <p className="text-lg text-brown-medium max-w-2xl mx-auto">
            We'd love to serve you our gourmet chaat creations
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="space-y-8"
          >
            <div className="bg-cream-secondary rounded-2xl p-8 border-2 border-dashed border-brown-light/30">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-spice rounded-full flex items-center justify-center flex-shrink-0">
                  <MapPin size={24} className="text-white" />
                </div>
                <div>
                  <h3 className="text-xl font-playfair font-bold text-brown-dark mb-2">
                    Location
                  </h3>
                  <p className="text-brown-medium">
                    Pimple Saudagar<br />
                    Pune, Maharashtra
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-cream-secondary rounded-2xl p-8 border-2 border-dashed border-brown-light/30">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-leaf rounded-full flex items-center justify-center flex-shrink-0">
                  <Mail size={24} className="text-white" />
                </div>
                <div>
                  <h3 className="text-xl font-playfair font-bold text-brown-dark mb-2">
                    Get in Touch
                  </h3>
                  <p className="text-brown-medium mb-4">
                    Order through Swiggy for fastest delivery
                  </p>
                  <a
                    href={SWIGGY_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block bg-spice text-white px-6 py-2.5 rounded-full hover:bg-spice-hover transition-all transform hover:-translate-y-0.5 font-bold"
                    data-testid="contact-order-now-btn"
                  >
                    Order on Swiggy
                  </a>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="bg-gradient-to-br from-turmeric/20 to-leaf/20 rounded-2xl p-8 lg:p-12 flex flex-col justify-center"
          >
            <h2 className="text-3xl font-playfair font-bold text-brown-dark mb-6">
              Order Now
            </h2>
            <p className="text-lg text-brown-medium mb-8 leading-relaxed">
              Experience the perfect blend of health and taste. Order your favorite gourmet chaat and refreshing coolers through Swiggy today!
            </p>
            <a
              href={SWIGGY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-spice text-white px-8 py-4 rounded-full hover:bg-spice-hover transition-all transform hover:-translate-y-1 hover:shadow-xl font-bold text-lg text-center"
              data-testid="contact-swiggy-btn"
            >
              Order on Swiggy Now
            </a>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-16 text-center bg-cream-accent/50 rounded-2xl p-8"
        >
          <p className="text-xl font-playfair font-bold text-brown-dark mb-2">
            Cloud Kitchen Model
          </p>
          <p className="text-brown-medium">
            We operate as a delivery-only cloud kitchen to ensure the freshest and most hygienic food reaches you directly.
          </p>
        </motion.div>
      </div>
    </div>
  );
}